import React from "react";
import {
  Box,
  Typography,
  Button,
  Grid,
  Card,
  CardContent,
  CardMedia,
  AppBar,
  Toolbar,
  IconButton,
  Chip,
  Stack,
} from "@mui/material";
import DirectionsBusFilledIcon from "@mui/icons-material/DirectionsBusFilled";
import HikingIcon from "@mui/icons-material/Hiking";
import TerrainIcon from "@mui/icons-material/Terrain";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import ElectricBoltIcon from "@mui/icons-material/ElectricBolt";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";

const featureCards = [
  {
    icon: <DirectionsBusFilledIcon color="primary" fontSize="large" />,
    title: "Track Any Bus",
    desc: "Find your bus's location, timings & more, in real time across Himachal.",
    btnText: "Track Bus",
    btnLink: "/",
  },
  {
    icon: <ReportProblemIcon color="error" fontSize="large" />,
    title: "Report Problems",
    desc: "Instantly submit complaints: delays, lost items, accidents & misconduct.",
    btnText: "Report Issue",
    btnLink: "/report",
  },
  {
    icon: <TerrainIcon color="success" fontSize="large" />,
    title: "Road Alerts",
    desc: "Stay updated about landslides, blockages and weather disruptions.",
    btnText: "See Alerts",
    btnLink: "/alerts",
  },
  {
    icon: <HikingIcon color="info" fontSize="large" />,
    title: "Lost & Found",
    desc: "Left something on a bus? Quickly log and find lost belongings here.",
    btnText: "Lost & Found",
    btnLink: "/lostfound",
  },
];

export default function Home() {
  return (
    <Box>
      {/* Hero Section */}
      <Box
        sx={{
          minHeight: "65vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          background: "linear-gradient(rgba(0,30,60,0.68),rgba(234,245,252,0.9)),url('https://images.unsplash.com/photo-1502082553048-f009c37129b9?auto=format&fit=crop&w=1200&q=80') center/cover",
        }}
      >
        <Box
          sx={{
            p: 4,
            display: "inline-block",
            bgcolor: "rgba(255,255,255,0.95)",
            borderRadius: 3,
            boxShadow: 4,
            mt: { xs: 10, md: 14 },
            mb: 6,
            textAlign: "center",
            maxWidth: "600px",
          }}
        >
          <Typography variant="h3" sx={{ fontWeight: 700, color: "#204060" }}>
            🚍 Safer Hills Travel
          </Typography>
          <Typography variant="h5" sx={{ color: "#3a6a5e", mb: 2, mt: 1 }}>
            Track. Report. Stay Safe.
          </Typography>
          <Typography variant="body1" sx={{ color: "#1a2952", mb: 3 }}>
            All Himachal buses, alerts, and help in one place—real-time tracking, quick complaints, road news, and lost+found, with instant notifications for you and your family.
          </Typography>
          <Button
            variant="contained"
            color="primary"
            size="large"
            endIcon={<ArrowRightAltIcon />}
            href="/alerts"
            sx={{ fontWeight: "bold", borderRadius: 10, px: 4, py: 1 }}
          >
            View Live Alerts
          </Button>
        </Box>
        <Stack direction="row" spacing={2} sx={{
          position: "absolute", right: { md: 80 }, bottom: { md: 40 }, zIndex: 2, display: { xs: "none", md: "flex" }
        }}>
          <Chip icon={<ElectricBoltIcon />} label="Landslide: Chamba-Kangra Road" color="error" variant="filled" />
          <Chip icon={<ElectricBoltIcon />} label="Bus #HP-56 blocked at Narkanda" color="warning" variant="filled" />
        </Stack>
      </Box>

      {/* Features Section */}
      <Box sx={{ background: "#f8fafc", pt: 5, pb: 7 }}>
        <Typography variant="h4" sx={{ fontWeight: 700, textAlign: "center", mb: 5, mt: 2, letterSpacing: ".02em" }}>
          What Can You Do Here?
        </Typography>
        <Grid container spacing={4} justifyContent="center">
          {featureCards.map((card, i) => (
            <Grid item xs={12} sm={6} md={3} key={card.title}>
              <Card
                sx={{
                  px: 2,
                  py: 4,
                  minHeight: 280,
                  borderRadius: 4,
                  boxShadow: 3,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  transition: "0.25s",
                  '&:hover': { boxShadow: 8, transform: 'scale(1.04)' }
                }}
              >
                {card.icon}
                <Typography variant="h6" sx={{ mt: 2, mb: 1, fontWeight: 600 }}>
                  {card.title}
                </Typography>
                <Typography variant="body2" sx={{ color: "#49586b", mb: 3 }}>
                  {card.desc}
                </Typography>
                <Button variant="contained" href={card.btnLink} sx={{ borderRadius: 8 }}>
                  {card.btnText}
                </Button>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>

      {/* Footer-like Quick Info */}
      <Box sx={{
        px: 2,
        py: 2,
        background: "linear-gradient(90deg,#355c7d 0,#6c5b7b 100%)",
        color: "#fff",
        textAlign: "center",
        fontWeight: 500,
        fontSize: "1.05rem",
      }}>
        🚩 Need Help? Call 1800-xxx-xxx (Transport Helpline) | Powered by local volunteers & Transport Department, Himachal Pradesh
      </Box>
    </Box>
  );
}
